import React from 'react';
import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';

interface ProblemCardProps {
  icon: LucideIcon;
  title: string;
  points: string[];
  isActive: boolean;
  onClick?: () => void;
}

export default function ProblemCard({ icon: Icon, title, points, isActive, onClick }: ProblemCardProps) {
  return (
    <motion.div
      layout
      onClick={onClick}
      animate={{
        scale: isActive ? 1 : 0.9,
        opacity: isActive ? 1 : 0.5,
        zIndex: isActive ? 10 : 0
      }}
      whileHover={{ scale: isActive ? 1 : 0.95 }}
      className="relative py-0"
    >
      <div className={`bg-white rounded-xl p-4 shadow-lg transition-all duration-300 border border-gray-100 cursor-pointer
        ${isActive ? 'shadow-xl ring-2 ring-primary ring-opacity-50' : 'shadow-md hover:shadow-lg'} 
        w-[300px] sm:w-[320px] md:w-[400px] mx-auto flex flex-col
      `}>
        {/* Bullet Points Section */}
        <div className="flex-1 mb-4">
          <ul className="space-y-2">
            {points.map((point, pointIndex) => (
              <li key={pointIndex} className="flex items-start text-gray-600">
                <span className="w-1.5 h-1.5 bg-primary rounded-full mt-2 mr-2 flex-shrink-0"></span>
                <span className="text-[15px] md:text-[16px] leading-relaxed">{point}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Icon and Title Section */}
        <div className="pt-3 border-t border-gray-100">
          <div className="flex items-center">
            <div className="w-10 h-10 rounded-full bg-gradient-to-r from-primary to-secondary p-0.5">
              <div className="w-full h-full rounded-full bg-white flex items-center justify-center">
                <Icon className="w-5 h-5 text-dark" />
              </div>
            </div>
            <h3 className="text-lg md:text-xl font-semibold text-gray-900 ml-3">{title}</h3>
          </div>
        </div>
      </div>
    </motion.div>
  );
}